module.exports = __webpack_public_path__ + "img/fond_monuments_belfort_montbeliard.e45412d8.svg";